module.exports = __webpack_public_path__ + "static/media/or.1f8293c0.svg";